export function recaptchaSuccess () {
  captchaValid = true;
  formValid && $("#sign-up-button").prop("disabled", false);
}
